<template>
  <div>
    <el-dialog title="" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="菜单名称" :label-width="formLabelWidth">
          <el-input v-model="className" auto-complete="off" :maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="排序(值大排前)" :label-width="formLabelWidth">
          <el-input v-model="classSort" auto-complete="off" :maxlength="3"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接" :label-width="formLabelWidth">
          <el-input v-model="classUrl" auto-complete="off" :maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateClass">取 消</el-button>
        <el-button type="primary" @click="qdCreateClass">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>删除菜单后将无法恢复，确定删除？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="classDeleteOK">确 定</el-button>
  </span>
    </el-dialog>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateClass(1)" size="small">创建菜单</el-button>
          <el-button type="warning" @click="openCreateClass(3)" size="small">修改菜单</el-button>
          <el-button type="danger" @click="openCreateClass(2)" size="small">删除菜单</el-button>
          <el-button type="danger" @click="openCreateClass(4)" size="small">测试按钮</el-button>
        </div>
      </el-header>
      <el-main :height="divHeight">
        选中：<span v-html="isName"></span>&nbsp;&nbsp;|&nbsp;<el-button type="danger" icon="el-icon-delete" size="mini" @click="checkAll" style="cursor: pointer;">删除选中</el-button><br/><br/>
        <el-scrollbar>
          <el-tree :data="data" :props="defaultProps" @current-change="handleNodeClick"></el-tree>
        </el-scrollbar>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'menu',
    data(){
      return {
        centerDialogVisible: false,
        dialogFormVisible:false,
        isType:0,
        isLevel:1,
        isSort:0,
        isId:'',
        isName:'',
        formLabelWidth: '120px',
        className:"",
        classSort:0,
        classUrl:"",
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        divHeight:500
      }
    },
    methods:{
      classDeleteOK:function () {
        if(this.isId == ""){
          this.$message({
            message: "请选择菜单",
            type: 'warning'
          });
          return false;
        }else{
          this.isType = 2;
          this.qdCreateClass();
          this.centerDialogVisible = false
        }
      },
      openCreateClass:function (val) {
        if(val == 3){
          if(this.isId == ""){
            this.$message({
              message: '请选择菜单',
              type: 'warning'
            });
          }else{
            this.className = this.isName;
            this.classSort = this.isSort;
            this.classUrl = this.classUrl;
            this.dialogFormVisible = true;
            this.isType = val;
          }
        }else if(val == 1){
          if(this.isLevel >= 2){
            this.$message({
              message: '菜单只支持到2级',
              type: 'warning'
            });
          }else{
            this.isLevel = 1;
            this.isSort = "";
            this.className = "";
            this.classSort = 0;
            this.classUrl = "";
            this.dialogFormVisible = true;
            this.isType = val;
          }
        }else if(val == 2){
          if(this.isId == ""){
            this.$message({
              message: '请选择菜单',
              type: 'warning'
            });
          }else{
            this.centerDialogVisible = true;
          }
        }else{
          /*this.$axios.post('/root/cscs',{
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.$message({
                message: response.message,
                type: 'success'
              });
            }else if(response.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });*/
        }
      },
      closeCreateClass:function () {
        this.className = "";
        this.classSort = 0;
        this.classUrl = "";
        this.dialogFormVisible = false;
      },
      deleteClass:function () {

      },
      qdCreateClass:async function () {
        if(this.isType == 1){
          if(this.className == ""){
            this.$message({
              message: '请输入菜单名称',
              type: 'warning'
            });
            return false;
          }
        }
        if(this.isType == 3){
          if(this.className == ""){
            this.$message({
              message: '请输入要修改菜单名称',
              type: 'warning'
            });
            return false;
          }
        }
        await this.$axios.post('/root/menuMessage',{
          "t":this.isType,
          "s":this.classSort,
          "l":this.isLevel,
          "id":this.isId,
          "url":this.classUrl,
          "n":this.className
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.addmenuClass();
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.className = "";
        this.classSort = 0;
        this.classUrl = "";
        this.dialogFormVisible = false;
      },
      addmenuClass:async function(){
        await this.$axios.post('/root/addmenuClass',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.data = response.data;
            this.divHeight = window.innerHeight-258;
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      handleNodeClick(data,checked,indeterminate) {
        this.isLevel = data.level;
        this.isSort = data.sort;
        this.isName = data.label;
        this.isId = data._id;
        this.classUrl = data.url;
      },
      checkAll(){
        this.isLevel = 1;
        this.isSort = 0;
        this.isName = "";
        this.isId = "";
        this.classUrl = "";
      }
    },
    mounted(){
      this.addmenuClass();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .el-scrollbar__wrap { overflow: scroll; width: 110%; height: 120%; }
  .el-main{overflow-x: hidden;overflow-y: auto}
</style>



// WEBPACK FOOTER //
// src/views/main/menu.vue